import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import SlidePickerDropdown from './SlidePickerDropdown';
import SlidePickerSheet from './SlidePickerSheet';
import { useFilteredSlides } from './useFilteredSlides';

const noop = () => {};

const SlidePicker = (props) => {
  const {
    children = noop,
    slides = [],
    slideIndex,
    setSlideIndex,
    track,
    uiMode
  } = props;

  const [filteredSlides, filterValue, setFilterValue] = useFilteredSlides(slides);

  const onItemClick = useCallback(index => {
    track('SlidePicker Click', {
      numberOfSlides: slides.length,
      slideIndex: index
    });
    setSlideIndex(index);
  }, [setSlideIndex, slides, track]);

  const onOpen = useCallback(() => {
    track('SlidePicker Open', {
      numberOfSlides: slides.length
    });
  }, [slides, track]);

  const onClose = useCallback(() => {
    setFilterValue('');
  }, [setFilterValue]);

  const onFilterChange = useCallback((value) => {
    setFilterValue(value);
  }, [setFilterValue]);

  const Component = uiMode === 'scroll' ? SlidePickerSheet : SlidePickerDropdown;

  return (
    <Component
      {...props}
      children={children}
      filteredSlides={filteredSlides}
      filterValue={filterValue}
      onItemClick={onItemClick}
      onOpen={onOpen}
      onClose={onClose}
      onFilterChange={onFilterChange}
    />
  )
};

SlidePicker.propTypes = {
  children: PropTypes.func,
  slides: PropTypes.array,
  slideIndex: PropTypes.number,
  setSlideIndex: PropTypes.func.isRequired,
  track: PropTypes.func.isRequired,
  uiMode: PropTypes.string
};

export default SlidePicker;
